const parseImagePromise = e => {
  return new Promise(resolve => {
    try {
      const clipboardData = e.clipboardData || window.clipboardData || e.originalEvent.clipboardData;
      if (clipboardData.items.length) {
        // 如果有多个item，找其中第一个图片的
        let list = Array.from(clipboardData.items);
        list = list.filter(item => item.type.match(/^image\//));
        const total = list.length;
        let count = 0;
        const resultList = [];
        list.forEach(item => {
          const reader = new window.FileReader();
          const blob = item.getAsFile();
          reader.onload = paste => {
            const photoUrl = paste.target.result;
            const reg = /^image\/(.+)$/;
            let fileExt = reg.exec(blob.type);
            fileExt = fileExt ? fileExt[1] : 'png';
            const random1 = Math.random();
            const file = new window.File([blob], `${random1.toString(36).substr(2)}.${fileExt}`, {
              type: blob.type,
              lastModified: new Date()
            });
            count += 1;
            resultList.push({
              file,
              photoUrl
            });
            if (total === count) {
              resolve(resultList);
            }
          };
          reader.readAsDataURL(blob);
        });
      }
    } catch (err) {
      console.log(err);
      resolve(null);
    }
  });
};

export { parseImagePromise };
